import { makeStyles } from "tss-react/mui";

import { Box, Theme, Typography } from "@mui/material";
import { PaneElement } from "@sidePanel/shared/PaneElement";

type SectionCardProps = {
    title: React.ReactNode;
    description?: React.ReactNode;
    content?: React.ReactNode;
    bottomContent?: React.ReactNode;
};

const useStyles = makeStyles()((theme: Theme) => ({
    card: {
        backgroundColor: theme.palette.emteria.background.paper,
        borderRadius: 12,
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        padding: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    headerSection: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    },
    description: {
        fontWeight: 400,
    },
}));

export const SectionCard = ({ title, description, content, bottomContent }: SectionCardProps) => {
    const { classes } = useStyles();

    return (
        <Box className={classes.card}>
            <Box className={classes.headerSection}>
                <PaneElement.Header>{title}</PaneElement.Header>
                {description ? (
                    <Typography variant="body1" color="text.primary" className={classes.description}>
                        {description}
                    </Typography>
                ) : null}
            </Box>
            {content}
            {bottomContent}
        </Box>
    );
};
